import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';

const OfferMiniDetails = (props) => {
    return (
        <div className="col-lg-6">
            <div data-aos="flip-left" data-aos-duration="1500" style={{ position: 'relative', padding: 20, margin: 15, borderRadius: 30, height: 500, backgroundImage: `url(${props.data?.img})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div style={{ position: 'absolute', bottom: 10, left: 10, textAlign: 'start'}}>
                    <h2 data-aos="fade-up" data-aos-duration="2000">{props.data?.title}</h2>
                    <h5 data-aos="fade-up" data-aos-duration="2500">{props.data?.description}</h5>
                    <Link data-aos="fade-up" data-aos-duration="3000" to={`/offer#${props.data?.tag}`} className="btn rounded-pill me-2 btn-global-style-solid">
                        Book event <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default OfferMiniDetails;